// Birthstone necklace builder (snippets/dogum-tasi.liquid).
// State: an ordered list of stones [{ month, name }], left → right on the bar. The count buttons and the per-row
// remove button change the list; the months come from the row selects; the order changes by dragging a stone in the
// preview, dragging a row by its handle, or the ↑ ↓ buttons. After every change the preview is redrawn, the rows are
// re-rendered, the "Birthstones" option of the (hidden) theme variant picker is set to the new count so the theme
// updates price and gallery, and the order summary line item property is rewritten.
if (!window.customElements.get('dogum-tasi')) {
  // Stone list used by the workshop (same as the Enos listing). Colours are sampled from the store's own birthstone
  // chart photo (product image 10): koyu = shadowed facets, renk = body colour, parlak = lit facets.
  const TASLAR = [
    { ay: 'jan', ad: 'January', kisa: 'Jan', tas: 'Garnet', koyu: '#4a0a10', renk: '#8a1624', parlak: '#d23b4c' },
    { ay: 'feb', ad: 'February', kisa: 'Feb', tas: 'Amethyst', koyu: '#40307d', renk: '#65529b', parlak: '#a791ca' },
    { ay: 'mar', ad: 'March', kisa: 'Mar', tas: 'Aquamarine', koyu: '#64a0b1', renk: '#99d1e4', parlak: '#c4ebf6' },
    { ay: 'apr', ad: 'April', kisa: 'Apr', tas: 'Diamond', koyu: '#8a8c90', renk: '#c9cacb', parlak: '#f8f8f6' },
    { ay: 'may', ad: 'May', kisa: 'May', tas: 'Emerald', koyu: '#1d2f15', renk: '#418247', parlak: '#7db862' },
    { ay: 'jun', ad: 'June', kisa: 'Jun', tas: 'Alexandrite', koyu: '#615e78', renk: '#a098b9', parlak: '#cac7dd' },
    { ay: 'jul', ad: 'July', kisa: 'Jul', tas: 'Ruby', koyu: '#a71246', renk: '#d12267', parlak: '#dc508f' },
    { ay: 'aug', ad: 'August', kisa: 'Aug', tas: 'Peridot', koyu: '#475215', renk: '#8f9f3e', parlak: '#cfda56' },
    { ay: 'sep', ad: 'September', kisa: 'Sep', tas: 'Sapphire', koyu: '#141a45', renk: '#2a3575', parlak: '#5669b0' },
    { ay: 'oct', ad: 'October', kisa: 'Oct', tas: 'Pink Tourmaline', koyu: '#bb7889', renk: '#eaa7b9', parlak: '#f9cedc' },
    { ay: 'nov', ad: 'November', kisa: 'Nov', tas: 'Citrine', koyu: '#9f3f09', renk: '#d97517', parlak: '#f4a22d' },
    { ay: 'dec', ad: 'December', kisa: 'Dec', tas: 'Blue Zircon', koyu: '#235192', renk: '#4d8ec4', parlak: '#83cbed' },
  ];
  const TAS = Object.fromEntries(TASLAR.map((t) => [t.ay, t]));
  const METAL = {
    gold: { koyu: '#9a6f1f', orta: '#d4a646', acik: '#f7e3a6' },
    silver: { koyu: '#7b7e84', orta: '#c3c6cb', acik: '#f4f5f7' },
    rose: { koyu: '#9a5c4d', orta: '#d39684', acik: '#f7d6ca' },
  };
  // mouse/trackpad: on touch screens focusing a <select> from script opens its picker, so the month select is only refocused here
  const inceIsaretci = () => matchMedia('(pointer: fine)').matches;
  const metalBul = (malzeme) => (/rose/i.test(malzeme) ? 'rose' : /white|silver/i.test(malzeme) ? 'silver' : 'gold');
  const kac = (deger) => parseInt(String(deger).match(/\d+/)?.[0] || '0', 10);

  class DogumTasi extends HTMLElement {
    connectedCallback() {
      if (this._hazir) return;
      this._hazir = true;
      const q = (s) => this.querySelector(s);
      this.formId = this.getAttribute('form-id');
      this.tasKonum = Number(this.dataset.stonePosition) || 2;
      this.malzemeKonum = Number(this.dataset.materialPosition) || 1;
      this.enFazla = Number(this.dataset.max) || 7;
      this.isimMax = Number(this.dataset.nameMax) || 10;
      this.varyantlar = JSON.parse(q('[data-varyantlar]').textContent);
      this.parcalar = JSON.parse(q('[data-parcalar]').textContent);
      this.olculer = JSON.parse(q('[data-olcu]').textContent);
      this.sahne = q('[data-sahne]');
      this.onizleme = q('[data-onizleme]');
      this.liste = q('[data-liste]');
      this.hata = q('[data-hata]');
      this.ozet = q('[data-ozet]');
      this.denetim = q('[data-denetim]');
      this.sayiEl = q('[data-sayi]');
      this.sayacNot = q('[data-sayac-not]');
      this.denendi = false;
      this.secili = -1;

      const varyant = this.temaVaryanti();
      this.malzeme = varyant ? varyant.o[this.malzemeKonum - 1] : '';
      const baslangic = varyant ? Math.max(1, kac(varyant.o[this.tasKonum - 1])) : 1;
      this.taslar = Array.from({ length: baslangic }, () => ({ ay: '', isim: '' }));

      q('[data-arttir]').addEventListener('click', () => this.sayiDegistir(this.taslar.length + 1));
      q('[data-azalt]').addEventListener('click', () => this.sayiDegistir(this.taslar.length - 1));

      // Rows: delegated events, the rows are re-rendered on every change
      this.liste.addEventListener('change', (e) => {
        const i = Number(e.target.closest('[data-sira]')?.dataset.sira);
        // update the rows in place: rebuilding them and focusing the new select reopened the month picker on phones
        if (e.target.matches('[data-ay]')) { this.taslar[i].ay = e.target.value; this.secili = i; this.guncelle(true, false); }
      });
      this.liste.addEventListener('input', (e) => {
        if (!e.target.matches('[data-isim]')) return;
        const i = Number(e.target.closest('[data-sira]').dataset.sira);
        this.taslar[i].isim = e.target.value.slice(0, this.isimMax);
        this.ozetYaz();
        this.ciz();
      });
      this.liste.addEventListener('click', (e) => {
        const b = e.target.closest('button'); if (!b) return;
        const i = Number(b.closest('[data-sira]').dataset.sira);
        if (b.matches('[data-yukari]')) this.tasi(i, i - 1);
        else if (b.matches('[data-asagi]')) this.tasi(i, i + 1);
        else if (b.matches('[data-kaldir]')) { this.taslar.splice(i, 1); this.secili = -1; this.sayiDegistir(this.taslar.length, true); }
      });
      this.listeSurukle();
      this.sahneSurukle();

      // Guide dialog
      const rehber = q('[data-rehber]');
      rehber.innerHTML = TASLAR.map((t) => `<li class="dogum-tasi__rehber-oge"><span class="dogum-tasi__nokta" data-rehber-ay="${t.ay}" style="--tas:${t.renk};--tas-parlak:${t.parlak};--tas-koyu:${t.koyu}"></span><span><strong>${t.ad}</strong><br>${t.tas}</span></li>`).join('');
      this.querySelectorAll('[data-ac]').forEach((b) => b.addEventListener('click', () => document.getElementById(b.dataset.ac)?.showModal()));
      this.querySelectorAll('dialog').forEach((d) => {
        d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
        d.querySelector('[data-kapat]')?.addEventListener('click', () => d.close());
      });

      // The theme's form calls reportValidity(): point the customer at the first stone without a month
      this.denetim.addEventListener('invalid', (e) => {
        e.preventDefault();
        this.denendi = true;
        this.guncelle(false);
        const bos = this.taslar.findIndex((t) => !t.ay);
        const sec = this.liste.querySelector(`[data-sira="${bos}"] [data-ay]`);
        if (sec) { sec.focus({ preventScroll: true }); setTimeout(() => sec.scrollIntoView({ block: 'center', behavior: 'smooth' }), 120); }
      });

      // Material changes come from the theme's own picker
      this._varyant = (e) => {
        const kaynak = e.target instanceof HTMLFormElement ? e.target.getAttribute('id') : null;
        if (kaynak !== this.formId || !e.detail?.variant) return;
        const o = e.detail.variant.options || [];
        this.malzeme = o[this.malzemeKonum - 1] || this.malzeme;
        // 14K has one stone less: trim if the new material cannot carry the current count
        const sinir = this.malzemeSiniri();
        if (this.taslar.length > sinir) { this.taslar.length = sinir; this.sayacNotu(`${this.malzeme} is available with up to ${sinir} stones.`); this.temaSec(); }
        this.guncelle(false);
      };
      document.addEventListener('variant:change', this._varyant);
      this.guncelle(false);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._varyant);
    }

    // ——— helpers

    temaVaryanti() {
      const id = document.getElementById(this.formId)?.querySelector('input[name="id"]')?.value;
      return this.varyantlar.find((v) => String(v.id) === String(id)) || this.varyantlar[0];
    }

    malzemeSiniri() {
      const sayilar = this.varyantlar.filter((v) => v.o[this.malzemeKonum - 1] === this.malzeme).map((v) => kac(v.o[this.tasKonum - 1]));
      return Math.min(this.enFazla, sayilar.length ? Math.max(...sayilar) : this.enFazla);
    }

    sayacNotu(metin) {
      this.sayacNot.textContent = metin;
      clearTimeout(this._not);
      this._not = setTimeout(() => { this.sayacNot.textContent = ''; }, 4000);
    }

    sayiDegistir(yeni, zatenCikarildi = false) {
      const sinir = this.malzemeSiniri();
      if (yeni < 1) { if (!zatenCikarildi) return; yeni = 1; }
      if (yeni > sinir) { this.sayacNotu(`Up to ${sinir} birthstones${sinir < this.enFazla ? ' in ' + this.malzeme : ''}.`); return; }
      while (this.taslar.length < yeni) this.taslar.push({ ay: '', isim: '' });
      if (this.taslar.length > yeni) this.taslar.length = yeni;
      this.temaSec();
      this.guncelle();
    }

    // Select "<n> Birthstone(s)" in the theme's hidden variant picker so price and gallery follow
    temaSec() {
      const picker = document.querySelector(`variant-picker[form-id="${this.formId}"]`);
      if (!picker) return;
      const hedef = this.taslar.length;
      const girdi = [...picker.querySelectorAll(`input[data-option-position="${this.tasKonum}"]`)].find((i) => {
        const etiket = picker.querySelector(`label[for="${CSS.escape(i.id)}"]`);
        return etiket && kac(etiket.textContent) === hedef;
      });
      if (girdi && !girdi.checked) { girdi.checked = true; girdi.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    tasi(den, ye) {
      if (ye < 0 || ye >= this.taslar.length || den === ye) return;
      const [t] = this.taslar.splice(den, 1);
      this.taslar.splice(ye, 0, t);
      this.secili = ye;
      this.guncelle();
      if (inceIsaretci()) this.liste.querySelector(`[data-sira="${ye}"] [data-ay]`)?.focus({ preventScroll: true });
    }

    // ——— render

    guncelle(denetle = true, satirYenile = true) {
      this.sayiEl.value = this.taslar.length;
      this.sayiEl.textContent = this.taslar.length;
      this.querySelector('[data-azalt]').disabled = this.taslar.length <= 1;
      const sinir = this.malzemeSiniri();
      this.querySelector('[data-arttir]').disabled = this.taslar.length >= sinir;
      // explain a lower limit (14K is made with up to 6 stones) while the + button is off because of it
      if (sinir < this.enFazla && this.taslar.length >= sinir) { clearTimeout(this._not); this.sayacNot.textContent = `Up to ${sinir} in ${this.malzeme}`; }
      else if (!this._not || this.sayacNot.textContent.startsWith('Up to ' + sinir + ' in')) this.sayacNot.textContent = '';
      this.onizleme.dataset.metal = metalBul(this.malzeme);
      if (satirYenile) this.satirlar();
      this.ciz();
      this.ozetYaz();
      const eksik = this.taslar.some((t) => !t.ay);
      this.denetim.setCustomValidity(eksik ? this.dataset.emptyText : '');
      this.hata.hidden = !(eksik && this.denendi);
      this.hata.textContent = eksik && this.denendi ? this.dataset.emptyText : '';
      if (denetle && !eksik) this.denendi = false;
      if (!satirYenile) this.satirDurum();
    }

    // bring the existing rows up to date (selected row, stone swatch, missing-month mark) without re-rendering them
    satirDurum() {
      this.liste.querySelectorAll('[data-sira]').forEach((satir) => {
        const i = Number(satir.dataset.sira), t = this.taslar[i], tas = TAS[t.ay];
        satir.classList.toggle('is-secili', i === this.secili);
        const nokta = satir.querySelector('.dogum-tasi__nokta');
        nokta.classList.toggle('is-bos', !tas);
        if (tas) { nokta.style.setProperty('--tas', tas.renk); nokta.style.setProperty('--tas-parlak', tas.parlak); nokta.style.setProperty('--tas-koyu', tas.koyu); }
        satir.querySelector('[data-ay]').classList.toggle('is-invalid', !t.ay && this.denendi);
      });
    }

    satirlar() {
      const secenekler = TASLAR.map((t) => `<option value="${t.ay}">${t.ad} – ${t.tas}</option>`).join('');
      const odak = document.activeElement && this.liste.contains(document.activeElement) ? document.activeElement : null;
      const odakSira = odak?.closest('[data-sira]')?.dataset.sira;
      const odakTur = odak?.matches('[data-isim]') ? 'isim' : odak?.matches('[data-ay]') ? 'ay' : null;
      this.liste.innerHTML = this.taslar.map((t, i) => {
        const tas = TAS[t.ay];
        const bos = !t.ay && this.denendi;
        return `<li class="dogum-tasi__satir${i === this.secili ? ' is-secili' : ''}" data-sira="${i}">
          <span class="dogum-tasi__tutamac" data-tutamac aria-hidden="true" title="Drag to reorder">⋮⋮</span>
          <span class="dogum-tasi__no">${i + 1}</span>
          <span class="dogum-tasi__nokta${tas ? '' : ' is-bos'}" style="${tas ? `--tas:${tas.renk};--tas-parlak:${tas.parlak};--tas-koyu:${tas.koyu}` : ''}" aria-hidden="true"></span>
          <select class="select dogum-tasi__ay${bos ? ' is-invalid' : ''}" data-ay aria-label="Birthstone ${i + 1}">
            <option value="" ${t.ay ? '' : 'selected'} disabled>Choose month</option>${secenekler}
          </select>
          <input class="input dogum-tasi__isim" type="text" data-isim maxlength="${this.isimMax}" placeholder="Name (optional)" aria-label="Name for stone ${i + 1} (optional)" value="${t.isim.replace(/"/g, '&quot;')}" autocomplete="off">
          <span class="dogum-tasi__oklar">
            <button type="button" class="dogum-tasi__ok" data-yukari aria-label="Move stone ${i + 1} left" ${i === 0 ? 'disabled' : ''}>↑</button>
            <button type="button" class="dogum-tasi__ok" data-asagi aria-label="Move stone ${i + 1} right" ${i === this.taslar.length - 1 ? 'disabled' : ''}>↓</button>
            <button type="button" class="dogum-tasi__ok dogum-tasi__kaldir" data-kaldir aria-label="Remove stone ${i + 1}" ${this.taslar.length <= 1 ? 'disabled' : ''}>×</button>
          </span>
        </li>`;
      }).join('');
      this.taslar.forEach((t, i) => { if (t.ay) this.liste.querySelector(`[data-sira="${i}"] [data-ay]`).value = t.ay; });
      if (odakSira !== undefined && odakTur && (odakTur === 'isim' || inceIsaretci())) {
        const el = this.liste.querySelector(`[data-sira="${odakSira}"] ${odakTur === 'isim' ? '[data-isim]' : '[data-ay]'}`);
        if (el) { el.focus({ preventScroll: true }); if (odakTur === 'isim') el.setSelectionRange(el.value.length, el.value.length); }
      }
    }

    // Bar geometry in the 420 × 112 scene. The bar is assembled from real photo tiles of the piece (all cut from
    // 4K product shots at the same bar height): [left end: ring + chain + end block][stone][block][stone]…[right end].
    // Units: the bar is h = 24 high; every other size follows the tiles' own pixel proportions.
    olcu() {
      const O = this.olculer[metalBul(this.malzeme)];
      const n = this.taslar.length, h = 24, k = h / O.H;
      const g = O.tas * k, ara = O.blok * k, eb = O.uc_sol.blok * k, ebSag = O.uc_sag.blok * k;
      const genislik = eb + n * g + (n - 1) * ara + ebSag;
      const x0 = 210 - genislik / 2, y0 = 52;
      return { n, g, h, ara, eb, ebSag, k, O, genislik, x0, y0 };
    }

    // index of the stone slot under scene x (for dragging)
    siraBul(x) {
      const { n, g, ara, eb, x0 } = this.olcu();
      return Math.max(0, Math.min(n - 1, Math.floor((x - x0 - eb + ara / 2) / (g + ara))));
    }

    ciz() {
      const metal = metalBul(this.malzeme), P = this.parcalar[metal];
      // fetch every tile of this metal once, so a newly picked month shows at once
      if (this.onYuklenen !== metal) { this.onYuklenen = metal; Object.values(P).forEach((u) => { new Image().src = u; }); }
      const { n, g, h, ara, eb, ebSag, k, O, genislik, x0, y0 } = this.olcu();
      const solW = O.uc_sol.w * k, solH = O.uc_sol.h * k, sagW = O.uc_sag.w * k, sagH = O.uc_sag.h * k;
      this.onizleme.style.setProperty('--dt-zemin', `rgb(${O.arka_plan.join(' ')})`);
      let s = `<defs><filter id="dt-golge" x="-10%" y="-200%" width="120%" height="500%"><feGaussianBlur stdDeviation="2.2"/></filter></defs>`;
      s += `<ellipse cx="${x0 + genislik / 2}" cy="${y0 + h + 3}" rx="${genislik / 2}" ry="2.6" fill="#4a3322" opacity=".22" filter="url(#dt-golge)"/>`;
      // ends: blok_x is where the end block starts inside the tile (ring and chain reach past it), then stones and blocks
      s += `<image href="${P.uc_sol}" x="${(x0 - O.uc_sol.blok_x * k).toFixed(2)}" y="${(y0 + h - solH).toFixed(2)}" width="${solW.toFixed(2)}" height="${solH.toFixed(2)}" preserveAspectRatio="none"/>`;
      const sagX = x0 + eb + n * g + (n - 1) * ara;
      s += `<image href="${P.uc_sag}" x="${(sagX - O.uc_sag.blok_x * k).toFixed(2)}" y="${(y0 + h - sagH).toFixed(2)}" width="${sagW.toFixed(2)}" height="${sagH.toFixed(2)}" preserveAspectRatio="none"/>`;
      this.taslar.forEach((t, i) => {
        const x = x0 + eb + i * (g + ara), tas = TAS[t.ay];
        const secili = i === this.secili;
        if (i < n - 1) s += `<image href="${P.blok}" x="${(x + g).toFixed(2)}" y="${y0}" width="${ara.toFixed(2)}" height="${h}" preserveAspectRatio="none"/>`;
        s += `<g class="dogum-tasi__tas" data-tas="${i}" tabindex="0" role="button" aria-label="Stone ${i + 1}${tas ? ': ' + tas.ad + ' ' + tas.tas : ': choose month'}">`;
        s += `<rect x="${x - ara / 2}" y="${y0 - 14}" width="${g + ara}" height="${h + 40}" fill="transparent"/>`;
        if (tas) s += `<image href="${P[t.ay]}" x="${x.toFixed(2)}" y="${y0}" width="${g.toFixed(2)}" height="${h}" preserveAspectRatio="none"/>`;
        else s += `<image href="${P.apr}" x="${x.toFixed(2)}" y="${y0}" width="${g.toFixed(2)}" height="${h}" preserveAspectRatio="none" opacity=".35" class="dogum-tasi__bos-tas"/><rect x="${(x + 1).toFixed(2)}" y="${y0 + 1}" width="${(g - 2).toFixed(2)}" height="${h - 2}" fill="none" stroke="#7a6a5c" stroke-width=".8" stroke-dasharray="2.5 2"/><text x="${(x + g / 2).toFixed(2)}" y="${y0 + h / 2 + 4}" text-anchor="middle" class="dogum-tasi__soru">?</text>`;
        if (secili) s += `<path d="M${(x + g / 2 - 4).toFixed(2)} ${y0 + h + 9}l4 -4l4 4" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>`;
        s += `<text x="${(x + g / 2).toFixed(2)}" y="${y0 + h + 21}" text-anchor="middle" class="dogum-tasi__ay-kisa${secili ? ' is-secili' : ''}">${tas ? tas.kisa : i + 1}</text>`;
        if (t.isim.trim()) s += `<text x="${(x + g / 2).toFixed(2)}" y="${y0 + h + 32}" text-anchor="middle" class="dogum-tasi__isim-kisa">${t.isim.trim().replace(/[<&>]/g, '').slice(0, 8)}</text>`;
        s += `</g>`;
      });
      this.sahne.innerHTML = s;
      this.kucukler(P);
    }

    // row and guide swatches show the real stone photos of the current metal
    kucukler(P) {
      this.querySelectorAll('[data-sira]').forEach((satir) => {
        const t = this.taslar[Number(satir.dataset.sira)], nokta = satir.querySelector('.dogum-tasi__nokta');
        if (nokta) nokta.style.backgroundImage = t && t.ay ? `url("${P[t.ay]}")` : '';
      });
      this.querySelectorAll('[data-rehber-ay]').forEach((n) => { n.style.backgroundImage = `url("${P[n.dataset.rehberAy]}")`; });
    }

    ozetYaz() {
      this.ozet.value = this.taslar.map((t, i) => {
        const tas = TAS[t.ay];
        return `${i + 1}. ${tas ? tas.kisa + ' – ' + tas.tas : '?'}${t.isim.trim() ? ' (' + t.isim.trim() + ')' : ''}`;
      }).join(' · ');
    }

    // Drag a stone sideways in the preview; tap a stone to jump to its row
    sahneSurukle() {
      let surukle = null;
      const svgX = (e) => { const r = this.sahne.getBoundingClientRect(); return ((e.clientX - r.left) / r.width) * 420; }; // viewBox is 420 wide
      const hedefSira = (x) => this.siraBul(x);
      this.sahne.addEventListener('pointerdown', (e) => {
        const tas = e.target.closest('[data-tas]'); if (!tas) return;
        surukle = { i: Number(tas.dataset.tas), x: svgX(e), el: tas, oynadi: false };
        this.sahne.setPointerCapture(e.pointerId);
      });
      this.sahne.addEventListener('pointermove', (e) => {
        if (!surukle) return;
        const dx = svgX(e) - surukle.x;
        if (Math.abs(dx) > 4) surukle.oynadi = true;
        if (surukle.oynadi) { surukle.el.setAttribute('transform', `translate(${dx} -6)`); surukle.el.classList.add('is-surukleniyor'); }
      });
      const birak = (e) => {
        if (!surukle) return;
        const { i, oynadi } = surukle; surukle = null;
        if (oynadi) this.tasi(i, hedefSira(svgX(e)));
        else { this.secili = i; this.guncelle(false); this.liste.querySelector(`[data-sira="${i}"] [data-ay]`)?.focus(); }
      };
      this.sahne.addEventListener('pointerup', birak);
      this.sahne.addEventListener('pointercancel', () => { surukle = null; this.ciz(); });
      this.sahne.addEventListener('keydown', (e) => {
        const tas = e.target.closest('[data-tas]'); if (!tas) return;
        const i = Number(tas.dataset.tas);
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.tasi(i, i - 1); this.sahne.querySelector(`[data-tas="${i - 1}"]`)?.focus(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.tasi(i, i + 1); this.sahne.querySelector(`[data-tas="${i + 1}"]`)?.focus(); }
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.liste.querySelector(`[data-sira="${i}"] [data-ay]`)?.focus(); }
      });
    }

    // Drag a row up or down by its handle
    listeSurukle() {
      let surukle = null;
      this.liste.addEventListener('pointerdown', (e) => {
        const tut = e.target.closest('[data-tutamac]'); if (!tut) return;
        const satir = tut.closest('[data-sira]');
        surukle = { i: Number(satir.dataset.sira), y: e.clientY, satir };
        satir.classList.add('is-surukleniyor');
        this.liste.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      this.liste.addEventListener('pointermove', (e) => {
        if (!surukle) return;
        surukle.satir.style.transform = `translateY(${e.clientY - surukle.y}px)`;
      });
      this.liste.addEventListener('pointerup', (e) => {
        if (!surukle) return;
        const satirlar = [...this.liste.querySelectorAll('[data-sira]')];
        let hedef = satirlar.findIndex((s) => { const r = s.getBoundingClientRect(); return e.clientY < r.top + r.height / 2; });
        if (hedef === -1) hedef = satirlar.length - 1;
        else if (hedef > surukle.i) hedef -= 1;
        const i = surukle.i; surukle = null;
        this.tasi(i, hedef);
        if (i === hedef) this.guncelle(false);
      });
    }
  }

  window.customElements.define('dogum-tasi', DogumTasi);
}
